import { Map } from 'immutable';

import {
  GET_PRODUCT_CHECKOUT_PAGE_START,
  GET_PRODUCT_CHECKOUT_PAGE_SUCCESS,
  GET_PRODUCT_CHECKOUT_PAGE_ERROR,
} from '../actions/productCheckoutPage';

const initialState = Map({
  data: null,
  error: null,
  loading: null,
});

const actionsMap = {
  [GET_PRODUCT_CHECKOUT_PAGE_START]: (state) => {
    return state.merge(
      Map({
        error: null,
        loading: true,
      }),
    );
  },
  [GET_PRODUCT_CHECKOUT_PAGE_SUCCESS]: (state, action) => {
    return state.merge(
      Map({
        data: action.data,
        loading: false,
      }),
    );
  },
  [GET_PRODUCT_CHECKOUT_PAGE_ERROR]: (state, action) => {
    return state.merge(
      Map({
        error: action.error,
        loading: false,
      }),
    );
  },
};

export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
